module.exports = __webpack_public_path__ + "img/equipo_de_proteccion_personal.2c6fb9e4.jpg";